import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Typography } from '@/components/Typography';
import type { Maybe } from '@/lib/types';
type PastExhibitionWraperPaddingSizeMap = {
  [key: string]: string;
};
export const PastExhibitionWraperDeskTopPaddingTopSizeMap: PastExhibitionWraperPaddingSizeMap =
  {
    first: '40px',
    middle: '0px',
    last: '0px',
    firstAndLast: '40px',
  };
export const PastExhibitionWraperMobilePaddingBottomSizeMap: PastExhibitionWraperPaddingSizeMap =
  {
    last: '16px',
    firstAndLast: '40px',
  };
export const PastExhibitionWraperDeskTopPaddingBottomSizeMap: PastExhibitionWraperPaddingSizeMap =
  {
    first: '32px',
    middle: '32px',
    last: '40px',
    firstAndLast: '40px',
  };
export const StyledContainer = styled(Container)`
  position: relative;
`;
export const PastExhibitionOuter = styled(Box)`
  ${({ theme }) => css`
    padding-left: 19px;
    margin: auto;
    position: relative;
    ${theme.media.md.up} {
      padding-left: 0px;
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      width: 1105px;
    }
  `};
`;
export const BackgroundWrapper = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      background-color: ${theme.colors.secondaryLightGrey};
    }
  `};
`;

export const PastExhibitionWraper = styled(Box)<{
  $imagePosition: Maybe<string>;
  $sizeType?: 'first' | 'middle' | 'last' | 'firstAndLast';
}>`
  align-content: start;
  display: flex;
  ${({ $imagePosition, theme, $sizeType }) => css`
    background-color: ${theme.colors.secondaryLightGrey};
    padding-left: 16px;
    padding-top: 16px;
    padding-bottom: ${$sizeType &&
    PastExhibitionWraperMobilePaddingBottomSizeMap[$sizeType]
      ? PastExhibitionWraperMobilePaddingBottomSizeMap[$sizeType]
      : '0px'};
    flex-direction: column-reverse;
    &::before {
      content: '';
      width: 13px;
      height: 13px;
      background-color: ${theme.colors.lightGray};
      border-radius: 50%;
      position: absolute;
      top: ${$sizeType &&
      ($sizeType === 'first' || $sizeType === 'firstAndLast')
        ? theme.spacing(0.5)
        : theme.spacing(0)};
      left: 1px;
      transform: translateX(-50%);
      z-index: 2;
    }
    &::after {
      border-left: 1px solid ${theme.colors.paleGray};
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      top: ${$sizeType &&
      ($sizeType === 'first' || $sizeType === 'firstAndLast')
        ? theme.spacing(0.5)
        : theme.spacing(0)};
      z-index: 1;
    }
    ${theme.media.md.up} {
      padding-left: 0px;
      padding-top: ${$sizeType &&
      PastExhibitionWraperDeskTopPaddingTopSizeMap[$sizeType]
        ? PastExhibitionWraperDeskTopPaddingTopSizeMap[$sizeType]
        : '0px'};
      padding-bottom: ${$sizeType &&
      PastExhibitionWraperDeskTopPaddingBottomSizeMap[$sizeType]
        ? PastExhibitionWraperDeskTopPaddingBottomSizeMap[$sizeType]
        : '0px'};
      flex-direction: ${$imagePosition === 'left' ? 'row' : 'row-reverse'};
      &::before {
        content: '';
        width: 12px;
        height: 12px;
        background-color: ${theme.colors.paleGray};
        border-radius: 50%;
        position: absolute;
        top: 22px;
        top: ${$sizeType &&
        PastExhibitionWraperDeskTopPaddingTopSizeMap[$sizeType]
          ? `calc(10px + ${PastExhibitionWraperDeskTopPaddingTopSizeMap[$sizeType]})`
          : '10px'};
        left: ${$imagePosition === 'right' ? 'calc(50% + 0.2px)' : 'auto'};
        right: ${$imagePosition === 'left' ? 'calc(50% - 12.3px)' : 'auto'};
        transform: translateX(-50%);
        z-index: 1;
      }
      &::after {
        border-left: 1px solid ${theme.colors.paleGray};
        bottom: 0;
        content: '';
        left: ${$imagePosition === 'right' ? 'calc(50% - 0.4px)' : 'auto'};
        right: ${$imagePosition === 'left' ? 'calc(50% - 0.4px)' : 'auto'};
        position: absolute;
        top: 0;
        transform: translateY(0);
        z-index: 1;
      }
    }
  `};
`;
export const PastExhibitionLeft = styled(Box)<{
  $imagePosition: Maybe<string>;
}>`
  ${({ $imagePosition, theme }) => css`
    display: block;
    margin: 10px auto 80px;
    max-width: 100%;
    position: relative;
    z-index: 2;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
    ${theme.media.md.up} {
      display: block;
      position: relative;
      z-index: 2;
      max-width: 640px;
      margin-top: 0;
      margin-left: ${$imagePosition === 'left' ? '0' : '32px'};
      margin-right: ${$imagePosition === 'left' ? '32px' : '0'};
    }
  `};
`;

export const PastExhibitionRight = styled(Box)<{
  $imagePosition: Maybe<string>;
}>`
  display: block;
  position: relative;
  z-index: 2;
  ${({ $imagePosition, theme }) => css`
    margin: 10px auto 80px;
    max-width: 100%;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
    ${theme.media.md.up} {
      max-width: 640px;
      margin-top: 0;
      margin-bottom: 0px;
      margin-left: ${$imagePosition === 'left' ? '32px' : '0'};
      margin-right: ${$imagePosition === 'left' ? '0' : '32px'};
    }
  `};
`;

export const CityTitle = styled(Typography)<{ $imagePosition: Maybe<string> }>`
  line-height: 37px;
  ${({ $imagePosition, theme }) => css`
    font-weight: 600;
    text-align: left;
    font-size: ${theme.fontSizes.h4Mobile};
    margin-bottom: 4px;
    ${theme.media.md.up} {
      margin-bottom: 0px;
      text-align: ${$imagePosition === 'left' ? 'left' : 'right'};
      font-size: ${theme.fontSizes.h3};
    }
  `};
`;

export const BoutiqueName = styled(Typography)<{
  $imagePosition: Maybe<string>;
}>`
  ${({ theme, $imagePosition }) => css`
    font-weight: 600;
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5Mobile};
    margin-bottom: 8px;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h4};
      text-align: ${$imagePosition === 'left' ? 'right' : 'left'};
    }
  `};
`;

export const DateTitle = styled(Box)<{ $imagePosition: Maybe<string> }>`
  ${({ $imagePosition, theme }) => css`
    color: ${theme.colors.default};
    font-family: ${theme.fontFamilies.italianPlate};
    text-align: left;
    font-size: ${theme.fontSizes.p1};
    ${theme.media.md.up} {
      text-align: ${$imagePosition === 'left' ? 'right' : 'left'};
    }
  `};
`;
export const DateSpan = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
  `};
`;
